import {
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material"
import useTranslationSharie from "../hooks/Language/useTranslation"
import React from "react"

const PackageOption = ({ packageOption, selectedPackage, onPackageSelect, index }) => {
  const t = useTranslationSharie()

  return (
    <Grid item xs={12} sm={4} key={index}>
      <Card variant='outlined' style={{ borderRadius: "0.8rem" }}>
        <CardContent sx={{ textAlign: "center" }}>
          <Typography variant='h6' fontWeight='bold'>
            {packageOption.amount} {t("Credits")}
          </Typography>
          <Typography variant='h5' color='primary' fontWeight='bold'>
            {packageOption.price}
          </Typography>
          <FormControl>
            <RadioGroup
              name='creditPackage'
              value={selectedPackage}
              onChange={() => onPackageSelect(packageOption.amount)}
            >
              <FormControlLabel value={packageOption.amount} control={<Radio />} />
            </RadioGroup>
          </FormControl>
        </CardContent>
      </Card>
    </Grid>
  )
}

export default React.memo(PackageOption)
